import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../../core/services/language.service';
import { UserStatus } from '../enums/user-status.enum';

@Pipe({
  name: 'userStatus',
  standalone: true
})
export class UserStatusPipe implements PipeTransform {

  private readonly translationKeys: Partial<Record<UserStatus, string>> = {
    [UserStatus.DELETED]: this.translate('shared.pipes.userStatus.deleted'),
    [UserStatus.SYSTEM]: this.translate('shared.pipes.userStatus.system'),
    [UserStatus.OSP_CONNECTOR]: this.translate('shared.pipes.userStatus.ospConnector'),
    [UserStatus.BRZ_CONNECTOR]: this.translate('shared.pipes.userStatus.brzConnector'),
    [UserStatus.UNKNOWN]: this.translate('general.unknown'),
  }

  constructor(private languageService: LanguageService) { }

  transform(value: UserStatus): string {
    return this.translationKeys[value] || this.translationKeys[UserStatus.UNKNOWN] as string;
  }

  private translate(key: string): string {
    return this.languageService.getInstant(key);
  }

}
